import React, { useContext } from 'react';

import { OtherLocationsTout } from 'registration/components/new_pages/OnboardingCurrentLocation/OtherLocationsTout';
import { OnboardingContext } from 'registration/containers/Onboarding';

import { styled } from 'shared/components/ihcl/styled';
import { Button } from 'shared/components/ihcl/v2/button';

const RecentGradSubtitle = styled('div', {
  fontWeight: '900',
  marginTop: '20px',
});

type OtherLocationsProps = {
  isRecentGrad?: boolean;
  openToRelocation?: boolean;
  setOpenToRelocation: Function;
};
export const OtherLocations = ({
  openToRelocation = null,
  setOpenToRelocation,
  isRecentGrad = false,
}: OtherLocationsProps) => {
  const { profileType = 'talent' } = useContext(OnboardingContext);

  return (
    <div id="other-locations">
      {!isRecentGrad && <OtherLocationsTout />}
      {isRecentGrad && (
        <>
          <RecentGradSubtitle>
            Are you interested in working in other cities or states?
          </RecentGradSubtitle>
          <p>
            Employers recruit for{' '}
            {profileType === 'tech' ? 'healthcare techs' : 'nurses'} with less
            than 1 year of experience across the U.S.
          </p>
        </>
      )}
      <Button
        onClick={() => setOpenToRelocation(false)}
        style={{
          minWidth: '100px',
          marginRight: '32px',
        }}
        variant={openToRelocation === false ? 'primary' : 'tertiary'}
      >
        No
      </Button>
      <Button
        onClick={() => setOpenToRelocation(true)}
        style={{
          minWidth: '100px',
        }}
        variant={openToRelocation === true ? 'primary' : 'tertiary'}
      >
        Yes
      </Button>
    </div>
  );
};
